import ReactModal from "react-modal";
import {useState} from "react";
import {HelioviewerModalContent} from './../helioviewermodal/helioviewermodalcontent.js';
import {HelioviewerModalErrorBox} from './../helioviewermodal/helioviewermodalerrorbox.js';
import {HelioviewerModalWarningBox} from './helioviewermodalwarningbox.js';
import {HELIOVIEWERERRORCODES} from './../../constants.js';


/**
 * Modal dialog that displays Helioviewer modal for a given dataset.
 *
 * @param props.title String title of modal.
 * @param props.missions String missions.
 * @param props.isHelioviewerModalOpen Whether to display the modal
 * @param props.setHelioviewerModalOpen Sets the value of isHelioviewerModalOpen
 * @param props.helioviewerSessionState Array of data that is used to save state of plots.
 * @param props.setHelioviewerSessionState Function that deals with setting the helioviewerSessionState parameter.
 * @return JSX
 */
export function HelioviewerModal(props) {
    const {
           title,
           mission,
           helioviewerSelection,
           isHelioviewerModalOpen,
           setHelioviewerModalOpen,
          } = props;
    // eslint-disable-next-line
    const [modalError, setModalError] = useState(null);
    const [helioviewerSessionState, setHelioviewerSessionState] = useState(null);
    const [help, setHelp] = useState(null);

    const helpContent = getHelioviewerHelpJSX();

    const onRequestClose = () => {
        setHelioviewerModalOpen(false);
    };

    return (
        <ReactModal
          overlayClassName="helioviewerModalOverlay"
          className="helioviewerModalContent"
          contentLabel="Helioviewer Modal"
          isOpen={isHelioviewerModalOpen}
          onRequestClose={onRequestClose}>

          <div className="helioviewerModalContainer">
            <div className="helioviewerModalTopTitle">
              Visualize Data
            </div>
            <div className="helioviewerUpperButtonsContainer">
              <div>
                <button onClick={()=>{setHelp(!help)}} className="helioviewerModalHelpButton">Help</button>
              </div>
              <div className="helioviewerModalCloseButtonContainer">
                <button onClick={onRequestClose} className="helioviewerModalCloseButton">Close</button>
              </div>
            </div>
            <br />
            {modalError &&
                 <HelioviewerModalErrorBox title= {HELIOVIEWERERRORCODES['002']} body={modalError.message}/>
            }
            {help ? <div>{helpContent}</div> : <div></div>}
            <HelioviewerModalContent
              title = {title}
              help = {help}
              mission = {mission}
              helioviewerSelection = {helioviewerSelection}
              helioviewerSessionState= {helioviewerSessionState}
              setHelioviewerSessionState= {setHelioviewerSessionState} />
          </div>
        </ReactModal>
    );
}

/**
 * Function that returns JSX for help.
 * @param help Object that contains 'status' and 'message'
 * @return JSX
 */
function getHelioviewerHelpJSX() {
    let helpContent = <HelioviewerModalWarningBox
                        title= {"What am I looking at?"}
                        body={"These visuals are images not raw data. Please note that the data has been compressed, which may alter the appearance. Also no color bar is provided."} />
    return helpContent
}
